import styled from 'styled-components';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { theme } from '_constants/theme';
import { ICONS_ALIASES } from '_constants/icons';
import { ROUTES } from '_constants/routes';

import ComparingTable from '_components/atomic/ComparingTable';
import Button from '_components/atomic/Button';
import Icon from '_components/atomic/Icon';
import { Divider } from '_components/atomic/layouts';

const { colors, devices, fontSizes, spaces } = theme;

const ITEMS = [
  {
    key: 'item1',
    title: 'Personal Asset Protection',
    iconColor: colors.gray[600],
  },
  {
    key: 'item2',
    title: 'No Registration Required',
    iconColor: colors.gray[600],
  },
  {
    key: 'item3',
    title: 'Flexible Management',
    iconColor: colors.gray[600],
  },
  {
    key: 'item4',
    title: 'Multiple Owners Allowed',
    iconColor: colors.gray[600],
  },
  {
    key: 'item5',
    title: 'Pass-through Taxation',
    iconColor: colors.gray[600],
  },
  {
    key: 'item6',
    title: 'Higher Credibility',
    iconColor: colors.gray[600],
  },
  {
    key: 'item7',
    title: 'Business Credit Profile',
    iconColor: colors.gray[600],
  },
  {
    key: 'item8',
    title: 'Eligible for S-Corp Tax Savings',
    iconColor: colors.gray[600],
  },
];

const COMPETITORS = [
  {
    key: 'LLC',
    title: (
      <>
        LLC
        <br />
        (Limited Liability Company)
      </>
    ),
    itemKeys: ['item1', 'item3', 'item4', 'item5', 'item6', 'item7', 'item8'],
  },
  {
    key: 'Sole Proprietorship',
    title: 'Sole Proprietorship',
    itemKeys: ['item2', 'item3', 'item5'],
  },
];

const StyledComparingSection = styled.div`
  max-width: 767px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${theme.colors.white};

  @media ${devices.tablet} {
    padding: 0px;
  }
`;

const StyledTitle = styled.div`
  margin-bottom: ${spaces.large4X}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 500;
  font-size: ${fontSizes.large11X}px;
  line-height: 150%;
  text-align: center;
  color: ${colors.gray[800]};

  @media ${devices.tablet} {
    margin-bottom: ${spaces.medium}px;
    font-size: ${fontSizes.large2X}px;
  }
`;

const ComparingLLCSection = () => {
  const router = useRouter();

  const handleStartRegisteringLLC = useCallback(() => {
    router.push(ROUTES.llcIncorporationFiling);
  }, [router]);

  return (
    <StyledComparingSection>
      <StyledTitle>
        LLC vs. Sole Proprietorship: Comparing Key Benefits
      </StyledTitle>
      <ComparingTable competitors={COMPETITORS} items={ITEMS} />
      <Divider size={spaces.large6X} desktop />
      <Divider size={spaces.regular} mobile />
      <Button
        suffix={<Icon alias={ICONS_ALIASES.arrowRight} color={colors.white} />}
        color={colors.indigo[600]}
        onClick={handleStartRegisteringLLC}
      >
        Start Registering Your LLC Now
      </Button>
    </StyledComparingSection>
  );
};

export default ComparingLLCSection;
